<template>
  <div class="panel panel-default panel-top-bordered">
    <div class="panel-heading">
      <div class="row">
        <div class="col-xs-18">
          <h5>
            Top Content
          </h5>
        </div>

        <div class="col-xs-6">
          <SelectWidget
              style="margin-top: 4px;"
              v-model="contentType"
              class="form-control input-sm"
              :options="[{value: 'articles_and_topics', label: 'Articles and topics'}, {value: 'events', label: 'Events'}, {value: 'files', label: 'Files'}, {value: 'jobs', label: 'Jobs'}, {value: 'registrations', label: 'Registrations'}]"
          />
        </div>
      </div>
    </div>

    <div class="panel-body">
      <LoadingSpinner v-if="loading"/>

      <div v-else-if="rows.length">
        <table class="table table-condensed table-striped">
        <thead>
        <tr>
          <th class="col-xs-12">
            Title
          </th>

          <th class="col-xs-4">
            Publication Date
          </th>

          <th class="col-xs-4 text-right">
            Impressions
          </th>

          <th class="col-xs-4 text-right">
            Page views
          </th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="row in rowsInPage">
          <td class="table__ellipsis">
            {{ row.title }}
          </td>

          <td >
            <span v-if="row.publication_date">
              {{ row.publication_date | date }}
            </span>

            <span v-else>
              (not published)
            </span>
          </td>

          <td class="text-right">
            {{ row.impression_count | number }}
          </td>

          <td class="text-right">
            {{ row.render_count | number }}
          </td>
        </tr>
        </tbody>
      </table>

        <SimplePager :current-page="page" :last-page="lastPage" @navigate="page = $event"/>
      </div>

      <div v-else class="text-center" style="padding: 20px 0">
        There is no data to display.
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import LoadingSpinner from "@/components/Layout/LoadingSpinner.vue";
import SimplePager from "@/components/Lists/SimplePager.vue";

export default {
  components: {SimplePager, LoadingSpinner, SelectWidget},

  props: {
    portalCompanyId: {
      required: true,
    },

    filters: {
      required: true,
    },
  },

  data() {
    return {
      result: null,

      contentType: 'articles_and_topics',

      page: 1,
      loading: true
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    filters() {
      this.load()
    },

    contentType() {
      this.page = 1
    }
  },

  computed: {
    rows() {
      return this.result.attributes.value[this.contentType]
    },

    rowsInPage() {
      return this.rows.slice((this.page - 1) * 10, this.page * 10 - 1)
    },

    lastPage() {
      return Math.ceil(this.rows.length / 10)
    }
  },

  methods: {
    load() {
      this.loading = true

      http.get('/api/v2/portal-companies/' + this.portalCompanyId + '/statistics/ranked-content/' + this.filters.from + '/' + this.filters.to).then(response => {
        this.result = response.data.data

        this.loading = false
      })
    },
  }
}
</script>
